import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Select } from '@sixui/ui';

import { getAppSettings } from '~/lib/appSettings';

export type IAppRegionSelectorProps = IOmit<ISelectProps, 'items'>;

export const AppRegionSelector = forwardRef<
  HTMLDivElement,
  IAppRegionSelectorProps
>(function AppRegionSelector(props, forwardedRef) {
  const { ...other } = props;
  const appSettings = getAppSettings();
  const regions = appSettings.enabledRegions;
  const items: Array<IFilterableListItem> = regions.map((region) => ({
    value: region,
  }));

  return <Select {...other} items={items} ref={forwardedRef} />;
});
